import type { HTMLAttributes } from 'react'

export interface SpinnerProps extends HTMLAttributes<HTMLSpanElement> {
  size?: 'sm' | 'md' | 'lg'
  /** Visible text beside the spinner. Also becomes the accessible label. */
  label?: string
}

export function Spinner({ size = 'md', label, className, ...rest }: SpinnerProps) {
  const spinner = (
    <span
      className={`rs-spinner rs-spinner--${size}${label ? '' : ` ${className ?? ''}`}`}
      role={label ? undefined : 'status'}
      aria-label={label ? undefined : 'Loading'}
      {...(label ? {} : rest)}
    />
  )
  if (!label) return spinner
  return (
    <span className={`rs-spinner-row ${className ?? ''}`} role="status" {...rest}>
      {spinner}
      <span>{label}</span>
    </span>
  )
}
